import { handleActions } from "redux-actions";
import {
  SET_LOADING,
  SET_PREV_PAGE_FILTERS,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_MEMBERSHIP_DRAFT_SUCCESS
} from "./membershipRevenueSagas";

export const initialState = {
  displayAutopays: false,
  prevPageFilters: { prevDate: null, prevRevenueType: null },
  initRequest: false,
  membershipDraft: {},
  initialized: false,
  isLoading: true
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_PREV_PAGE_FILTERS]: (state, action) => ({
      ...state,
      prevPageFilters: { ...action.payload }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      initRequest: true
    }),
    [FETCH_MEMBERSHIP_DRAFT_SUCCESS]: (state, action) => ({
      ...state,
      initialized: action.payload.initialized || state.initialized,
      membershipDraft: { ...action.payload },
      displayAutopays: action.payload.displayAutopays
    })
  },
  initialState
);
